<template>
    <b-container fluid class="max-width my-4">
        <b-button variant="link" class="text-secondary px-0" @click="goBack">
            <b-icon-arrow-left-short variant="secondary" font-scale="1.5" class="mb-n1"></b-icon-arrow-left-short>
            {{trans('webinars.dashboard.all_webinars')}}
        </b-button>
        <div class="row justify-content-center" v-if="registrationChecked">
            <div class="col-12 col-sm-10 col-md-8" v-if="!registrationCompleted">
                <webinar-registration-form :session-id="sessionId" @registrationComplete="checkRegistration"/>
            </div>
            <div class="col-12 col-md-6" v-else>
                <webinar-registration-completed :session-id="sessionId" :webinar-detail-nav="nav"/>
            </div>
        </div>
    </b-container>
</template>

<script>
    import WebinarRegistrationCompleted from "./WebinarRegistrationCompleted";
    import WebinarRegistrationForm from "./WebinarRegistrationForm";

    export default {
        name: "WebinarRegistration",
        components:{WebinarRegistrationForm, WebinarRegistrationCompleted},
        props:{
            sessionId: String
        },
        data() {
            return {
                registrationCompleted: false,
                registrationChecked: false,
                nav: null
            }
        },
        mounted() {
            this.checkRegistration();
        },
        methods:{
            checkRegistration(){
                this.$emit('registrationCompleted');
                this.$axios.get(`/api/rest/webinar/${this.sessionId}/checkIfRegistered`)
                    .then(res => {
                        this.registrationChecked = true;
                        this.registrationCompleted = res.data.exists === true;
                        this.nav = res.data.nav;
                    }).catch(err => {
                        console.log(err);
                        this.goBack();
                    })
            },
            goBack(){
                this.$router.replace('/webinar');
            }
        },
    }
</script>